import { getFilters } from './searchFiltersUtils'

function searchFilters(
  $q,
  $rootScope,
  siteService,
  webskedService,
  settingsService,
  toastr,
  pharosService
) {
  this.getFilters = getFilters(
    siteService,
    webskedService,
    settingsService,
    toastr,
    pharosService
  )
}

export default [
  '$q',
  '$rootScope',
  'siteService',
  'webskedService',
  'settingsService',
  'toastr',
  'pharosService',
  searchFilters,
]
